import { Pagination } from '@cloudscape-design/components';
import {
  useEffect,
  useState,
  forwardRef,
  ForwardedRef,
  useImperativeHandle,
} from 'react';

export interface AppPaginationProps {
  nextToken?: string;
  onChange: (nextToken?: string) => void;
}

export interface AppPaginationRef {
  clearTokens: () => void;
}

const AppPagination = forwardRef(
  ({ nextToken, onChange }: AppPaginationProps, ref: ForwardedRef<AppPaginationRef>) => {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPage, setTotalPage] = useState<number>(1);
    const [tokenMap, setTokenMap] = useState<Map<number, string>>(new Map());

    function clearTokens() {
      setTokenMap(new Map());
      setCurrentPage(1);
      setTotalPage(1);
    }

    // Expose methods to parent component via ref
    useImperativeHandle(ref, () => ({
      clearTokens,
    }));

    useEffect(() => {
      if (nextToken) {
        setTokenMap((prevMap) => {
          // Check if token already exists in the map
          if (Array.from(prevMap.values()).includes(nextToken)) {
            return prevMap;
          }

          const newMap = new Map(prevMap);
          newMap.set(newMap.size + 1, nextToken);
          setTotalPage(newMap.size + 1);
          return newMap;
        });
      }
    }, [nextToken]);

    return (
      <Pagination
        currentPageIndex={currentPage}
        pagesCount={totalPage}
        onChange={({ detail }) => {
          setCurrentPage(detail.currentPageIndex);
          const token = tokenMap.get(detail.currentPageIndex - 1);
          onChange(token);
        }}
      />
    );
  },
);

export default AppPagination;
